module.exports = __webpack_public_path__ + "static/media/hcs.e3eea6e4.png";